import { Bot } from "lucide-react";
import type { ChatGptFilter } from "../lib/useChatGptFilter";

const OPTS: Array<{ v: ChatGptFilter; label: string; title: string }> = [
  { v: "all", label: "Tümü", title: "ChatGPT tasarımları dahil hepsi" },
  { v: "only", label: "Yalnız", title: "Yalnız ChatGPT ile oluşturulan tasarımlar" },
  { v: "hide", label: "Gizle", title: "ChatGPT ile oluşturulan tasarımları gizle" },
];

/** Tasarim listelerinde ChatGPT filtresi: Tumu / Yalniz / Gizle (son secim hatirlanir) */
export function ChatGptFilterButton({ value, onChange, compact = false }: { value: ChatGptFilter; onChange: (v: ChatGptFilter) => void; compact?: boolean }) {
  const text = compact ? "text-xs" : "text-sm";
  return (
    <div className={`inline-flex items-center overflow-hidden rounded-lg border ${value === "all" ? "border-gray-200" : "border-violet-400"}`}
      title="ChatGPT ile oluşturulan tasarımlar (son seçim hatırlanır)">
      <span className={`flex items-center gap-1 bg-gray-50 px-2 ${compact ? "py-1" : "py-2"} ${text} font-medium text-gray-600`}>
        <Bot className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} /> ChatGPT
      </span>
      {OPTS.map((o) => (
        <button key={o.v} type="button" onClick={() => onChange(o.v)} title={o.title}
          className={`border-l px-2 ${compact ? "py-1" : "py-2"} ${text} transition-colors ${
            value === o.v
              ? o.v === "hide" ? "bg-gray-700 font-medium text-white" : o.v === "only" ? "bg-violet-600 font-medium text-white" : "bg-white font-medium text-gray-800"
              : "text-gray-500 hover:bg-gray-50"
          }`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
